import { render, staticRenderFns } from "./DesktopResolutionSelector.vue?vue&type=template&id=34b025bb&"
import script from "./DesktopResolutionSelector.vue?vue&type=script&lang=js&"
export * from "./DesktopResolutionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports